import { useIntl } from 'react-intl';
import AccionaButton from '../../../../components/AccionaButton';
import AccionaResult from '../../../../components/AccionaResult';
import { Form } from 'antd';
import AntdDatePicker from '../../../../components/AntdDatePicker';
import AntdFormItem from '../../../../components/AntdFormItem';
import AntdInput from '../../../../components/AntdInput';
import { useSelector } from 'react-redux';
import { useContext, useEffect, useState } from 'react';
import TextArea from 'antd/es/input/TextArea';
import AntdSelect from '../../../../components/AntdSelect';
import { useNavigate, useParams } from 'react-router-dom';
import {
  CONSTRUCTION_PROCESS_OPTIONS,
  NON_CONFORMITY_TYPE_OPTIONS,
} from '../../../../constants/nonConformityOptions';
import {
  createNonConformity,
  getNonConformity,
  updateNonConformity,
} from '../../../../services/api/nonConformity';
import { getConcreteBatch } from '../../../../services/api/concreteBatches';
import dayjs from 'dayjs';
import { MainContext } from '../../../../context/MainContext';
import { NotificationsContext } from '../../../../context/NotificationsContext';

const NonConformity = () => {
  const intl = useIntl();
  const [form] = Form.useForm();
  const { me } = useSelector(({ auth }) => auth);
  const { ncId, batch } = useParams();
  const navigate = useNavigate();
  const { setLoading, setError } = useContext(MainContext);
  const [showSuccess, setShowSuccess] = useState(false);
  const { pushNotification } = useContext(NotificationsContext);

  useEffect(() => {
    form.setFieldsValue({
      responsible: me?.email,
    });
  }, [me, form]);

  useEffect(() => {
    if (batch) {
      setLoading(true);
      getConcreteBatch(batch)
        .catch((err) => navigate(-1))
        .finally(() => setLoading(false));
    }
  }, [batch, navigate, setLoading]);

  useEffect(() => {
    if (ncId) {
      getNonConformity(ncId)
        .then((response) => {
          const ncData = response.data;
          form.setFieldsValue({
            ...ncData,
            created: ncData.created
              ? dayjs(ncData.created, 'DD/MM/YYYY')
              : null,
          });
        })
        .catch((err) => navigate(-1));
    }
  }, [ncId, form, navigate]);

  if (showSuccess) {
    return (
      <AccionaResult
        id="successResult"
        icon={
          <i
            className="fas fa-check-circle fa-8x"
            style={{ color: '#82c91e' }}
          />
        }
        title={intl.formatMessage({
          id: ncId
            ? 'pages.quality.ocr.nonConformity.success.edit'
            : 'pages.quality.ocr.nonConformity.success.create',
        })}
        className="success"
        extra={[
          <div
            key="extraSuccess1"
            className="form-row"
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
              marginTop: '25px',
            }}
          >
            <AccionaButton
              id="successBtn"
              onClick={() => navigate(-1)}
              msg={intl.formatMessage({ id: 'button.create.end' })}
            />
          </div>,
        ]}
      />
    );
  }

  return (
    <div className="row">
      <div
        className="col-sm-12"
        style={{
          fontSize: '1.1em',
          fontWeight: 500,
          textTransform: 'uppercase',
          marginBottom: '10px',
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        {intl.formatMessage({
          id: `routes.ocr.nonConformity.${ncId ? 'edit' : 'create'}`,
        })}
      </div>
      <div className="col-sm-12">
        <div style={{ backgroundColor: '#ffffff', padding: '20px' }}>
          <Form form={form} layout="vertical">
            <div className="row">
              <div className="col-sm-12 col-md-4">
                <AntdFormItem
                  label={intl.formatMessage({
                    id: 'pages.quality.ocr.nonConformity.field.openDate',
                  })}
                  name="created"
                  rules={[
                    {
                      required: true,
                      message: intl.formatMessage({ id: 'required' }),
                    },
                  ]}
                >
                  <AntdDatePicker
                    size="xLarge"
                    showTime={false}
                    format="DD/MM/YYYY"
                  />
                </AntdFormItem>
              </div>
              <div className="col-sm-12 col-md-4">
                <AntdFormItem
                  label={intl.formatMessage({
                    id: 'pages.quality.ocr.nonConformity.field.responsible',
                  })}
                  name="responsible"
                  rules={[
                    {
                      required: true,
                      message: intl.formatMessage({ id: 'required' }),
                    },
                  ]}
                >
                  <AntdInput size="xLarge" disabled value={me?.email} />
                </AntdFormItem>
              </div>
              <div className="col-sm-12 col-md-4">
                <AntdFormItem
                  label={intl.formatMessage({
                    id: 'pages.quality.ocr.nonConformity.field.detectedBy',
                  })}
                  name="detected_by"
                  rules={[
                    {
                      required: true,
                      message: intl.formatMessage({ id: 'required' }),
                    },
                  ]}
                >
                  <AntdSelect
                    size="xLarge"
                    style={{ width: '100%' }}
                    options={[
                      {
                        value: '1_Cliente / Client',
                        label: intl.formatMessage({
                          id: 'pages.quality.ocr.nonConformity.detectedBy.client',
                        }),
                      },
                      {
                        value: '2_Control Interno / Internal Control',
                        label: intl.formatMessage({
                          id: 'pages.quality.ocr.nonConformity.detectedBy.internalControl',
                        }),
                      },
                      {
                        value: '3_Otros / Others',
                        label: intl.formatMessage({
                          id: 'pages.quality.ocr.nonConformity.detectedBy.others',
                        }),
                      },
                    ]}
                  />
                </AntdFormItem>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <AntdFormItem
                  label={intl.formatMessage({
                    id: 'pages.quality.ocr.nonConformity.field.resume',
                  })}
                  name="resume"
                  rules={[
                    {
                      required: true,
                      message: intl.formatMessage({ id: 'required' }),
                    },
                    {
                      max: 45,
                      message: intl.formatMessage(
                        {
                          id: 'validations.maxLength',
                        },
                        { max: 45 },
                      ),
                    },
                  ]}
                >
                  <AntdInput size="xLarge" />
                </AntdFormItem>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <AntdFormItem
                  label={intl.formatMessage({
                    id: 'pages.quality.ocr.nonConformity.field.location',
                  })}
                  name="location"
                  rules={[
                    {
                      required: true,
                      message: intl.formatMessage({ id: 'required' }),
                    },
                    {
                      max: 45,
                      message: intl.formatMessage(
                        {
                          id: 'validations.maxLength',
                        },
                        { max: 45 },
                      ),
                    },
                  ]}
                >
                  <AntdInput size="xLarge" />
                </AntdFormItem>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <AntdFormItem
                  label={intl.formatMessage({
                    id: 'pages.quality.ocr.nonConformity.field.process',
                  })}
                  name="process"
                  rules={[
                    {
                      required: true,
                      message: intl.formatMessage({ id: 'required' }),
                    },
                  ]}
                >
                  <AntdSelect
                    style={{ width: '100%' }}
                    size="xLarge"
                    options={CONSTRUCTION_PROCESS_OPTIONS}
                  />
                </AntdFormItem>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <AntdFormItem
                  label={intl.formatMessage({
                    id: 'pages.quality.ocr.nonConformity.field.type',
                  })}
                  name="type"
                  rules={[
                    {
                      required: true,
                      message: intl.formatMessage({ id: 'required' }),
                    },
                  ]}
                >
                  <AntdSelect
                    size="xLarge"
                    style={{ width: '100%' }}
                    options={NON_CONFORMITY_TYPE_OPTIONS}
                  />
                </AntdFormItem>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <AntdFormItem
                  label={intl.formatMessage({
                    id: 'pages.quality.ocr.nonConformity.field.description',
                  })}
                  name="description"
                  rules={[
                    {
                      required: true,
                      message: intl.formatMessage({ id: 'required' }),
                    },
                    {
                      max: 500,
                      message: intl.formatMessage(
                        {
                          id: 'validations.maxLength',
                        },
                        { max: 500 },
                      ),
                    },
                  ]}
                >
                  <TextArea style={{ width: '100%' }} size="xLarge" rows={8} />
                </AntdFormItem>
              </div>
            </div>
          </Form>
        </div>
      </div>
      <div
        className="col-sm-12"
        style={{ display: 'flex', justifyContent: 'space-between' }}
      >
        <AccionaButton
          msg={intl.formatMessage({ id: 'back' })}
          onClick={() => navigate(-1)}
          classIcon="icon fas fa-chevron-left"
          style={{
            float: 'right',
            marginTop: '20px',
            marginRight: '0px',
          }}
        />
        <AccionaButton
          msg={intl.formatMessage({
            id: `routes.ocr.nonConformity.${ncId ? 'edit' : 'create'}`,
          })}
          disabled={!me?.is_active}
          onClick={() => {
            if (ncId) {
              form
                .validateFields()
                .then(() => {
                  const createdValue = form.getFieldValue('created');
                  updateNonConformity(ncId, {
                    ...form.getFieldsValue(),
                    created:
                      createdValue &&
                      dayjs.isDayjs(createdValue) &&
                      createdValue.isValid()
                        ? createdValue.format('DD/MM/YYYY')
                        : null,
                  })
                    .then(() => setShowSuccess(true))
                    .catch((err) => {
                      setError(err);
                    });
                })
                .catch(() => {
                  pushNotification({
                    message: intl.formatMessage({
                      id: 'pages.quality.ocr.nonConformity.error.validation',
                    }),
                    type: 'error',
                  });
                });
            } else {
              form
                .validateFields()
                .then(() => {
                  const createdValue = form.getFieldValue('created');
                  createNonConformity(
                    {
                      ...form.getFieldsValue(),
                      created:
                        createdValue &&
                        dayjs.isDayjs(createdValue) &&
                        createdValue.isValid()
                          ? createdValue.format('DD/MM/YYYY')
                          : null,
                    },
                    batch,
                  )
                    .then(() => setShowSuccess(true))
                    .catch((err) => {
                      console.error(err);
                      setError(err);
                    });
                })
                .catch(() => {
                  pushNotification({
                    message: intl.formatMessage({
                      id: 'pages.quality.ocr.nonConformity.error.validation',
                    }),
                    type: 'error',
                  });
                });
            }
          }}
          classIcon={`icon fas fa-${ncId ? 'edit' : 'plus'}`}
          style={{
            float: 'right',
            marginTop: '20px',
            marginRight: '0px',
          }}
        />
      </div>
    </div>
  );
};

export default NonConformity;
